export default __webpack_public_path__ + "media/color/moac-478fad90.svg";